import { FormControl, InputLabel, Grid, MenuItem, Paper, Select, Typography, IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { DataGrid, GridColDef, gridClasses } from '@mui/x-data-grid';
import axios from 'axios';
import { useEffect, useState, useRef } from 'react';
import { apiString as API_URL, parentUrl } from '../../../../utils/constants';
import WidgetLoading from '../../Shared/WidgetLoading';
import Authorization from '../../../../utils/Authorization';
import { dateFormatter } from '../../../../utils/timeFormat';
import { isDefaultDate } from '../../../../utils/common';

const MembersMissingGender = () => {
    const authData = new Authorization();
    const [memberMissingGender, setMemberMissingGender] = useState([]);
    const [rows, setRows] = useState([]);
    const [isFetched, setIsFetched] = useState<boolean>(false);
    const [show, setShow] = useState(false);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(15);

    const [selectedStatus, setSelectedStatus] = useState('Active');

    const selectedStatusOnChangeHandler = (e) => {
        setSelectedStatus(e.target.value);
        const copy = [...memberMissingGender];
        if (e.target.value === 'All') {
            setRows(copy);
        } else {
            const filtered = copy.filter((el) => el.Status === e.target.value);
            setRows(filtered);
        }
    };
    const ref = useRef(null);

    const handleClick = (event) => {
        setShow(!show);
    };

    useEffect(() => {
        setIsFetched(false);
        const changeFilter = async () => {
            setIsFetched(false);
            const response = await axios.get(`${API_URL}/member/getmembersmissinggender`);
            setMemberMissingGender(response.data);

            const filtered = response.data.filter((el) => el.Status === 'Active');
            setRows(filtered);
            setIsFetched(true);
        };
        changeFilter();
    }, [authData.UserId, setMemberMissingGender, setIsFetched]);

    const columns: GridColDef[] = [
        {
            field: 'LastName',
            headerName: 'Last Name',
            flex: 1,
        },
        {
            field: 'FirstName',
            headerName: 'First Name',
            flex: 1,
        },
        {
            field: 'DOB',
            headerName: 'DOB',
            flex: 1,
            valueGetter: (value, row) => `${isDefaultDate(row.DOB) ? '-' : dateFormatter(new Date(row.DOB))}`,
        },
        {
            field: 'Gender',
            headerName: 'Gender',
            flex: 1,
        },
        {
            field: 'Status',
            headerName: 'Status',
            flex: 1,
        },
    ];

    const activeStatuses = [
        'Undetermined',
        'Active',
        'Scheduled',
        'HRA in Review',
        'Uncompensated Care',
        'Suspended',
        'FUHFUM In-Progress',
        'Lost Insurance Coverage',
        'Preparing For Graduation',
        'Incarcerated',
    ];

    return (
        <Grid size={{ xs: 12, lg: 6 }}>
            <Paper
                className="smartdashboard-widget"
                elevation={5}
                sx={{ height: 'calc(100vh - 140px)', maxHeight: '650px', display: 'flex', flexDirection: 'column', overflow: 'auto' }}
            >
                <Grid container spacing={2} paddingLeft={2} paddingRight={2}>
                    <Grid size={12} textAlign="center">
                        <Typography color={'primary'} variant="h6" textAlign={'center'} ref={ref}>
                            Members Missing Gender
                            <Tooltip
                                open={show}
                                title={
                                    <div>
                                        <Typography variant="caption">Open members who have a Gender of "Non-Declared"</Typography>
                                    </div>
                                }
                                PopperProps={{ style: { zIndex: 1000 } }}
                            >
                                <IconButton onClick={handleClick}>
                                    <InfoIcon sx={{ width: '18px', height: '18px' }} />
                                </IconButton>
                            </Tooltip>
                        </Typography>
                    </Grid>
                    <Grid size={4}>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Filter by</InputLabel>
                            <Select
                                value={selectedStatus}
                                label="Filter by"
                                name="filter"
                                onChange={selectedStatusOnChangeHandler}
                                MenuProps={{ PaperProps: { sx: { maxHeight: 250 } } }}
                            >
                                <MenuItem key="All" value="All">
                                    All
                                </MenuItem>
                                {activeStatuses.map((state, index) => {
                                    return (
                                        <MenuItem key={index} value={state}>
                                            {state}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={12} marginTop={1}>
                        <div style={{ width: '100%', height: 'calc(100vh - 285px)', maxHeight: '500px', position: 'relative' }}>
                            {!isFetched && <WidgetLoading />}
                            <DataGrid
                                onCellClick={(params: any) => {
                                    window.open(`${parentUrl}provider/members-list/member-chart/${params.row.Id}/member-profile`, '_blank');
                                }}
                                rows={rows}
                                columns={columns}
                                paginationModel={{ pageSize: pageSize, page: page }}
                                pageSizeOptions={[5]}
                                onPaginationModelChange={(model) => {
                                    setPageSize(model.pageSize);
                                    setPage(model.page);
                                }}
                                getRowId={(row) => row.Id}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    [`& .${gridClasses.cell}`]: {
                                        py: 1,
                                    },
                                }}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
};

export default MembersMissingGender;
